<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">External Links
                </h3>
                <p class="mt-1 text-sm leading-5 text-gray-600">
                    Navigation menu links
                </p>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">

                    <div v-if="menuLinks.length" class="flex flex-col">
                        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                            <div
                                class="align-middle inline-block min-w-full overflow-hidden border-b border-gray-200">
                                <table class="min-w-full">
                                    <tbody class="bg-white">
                                    <tr v-for="link in menuLinks">
                                        <td class="px-2 py-4 whitespace-nowrap border-b-1 border-gray-200 text-sm leading-5 font-medium text-gray-900">
                                            <div>{{ link.text }}</div>
                                            <div class="italic text-gray-400">{{ link.href }}</div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap border-b-1 border-gray-200">
                                            <form @submit.prevent="deleteLink(link.id)">
                                                <button type="submit" class="focus:outline-none float-right">
                                                    <svg class="" width="24" height="24" viewBox="0 0 24 24"
                                                         fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
                                                            stroke="#4A5568" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round"/>
                                                    </svg>
                                                </button>
                                            </form>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-else><p>No links yet.</p></div>

                    <form @submit.prevent="submit">
                        <div class="mt-12 grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-4">
                                <label for="link_text"
                                       class="block text-sm font-medium leading-5 text-gray-700">Link Text
                                </label>
                                <div class="mt-1">
                                    <InputText id="link_text" v-model="form.text"/>
                                    <div class="text-red-400 text-sm" v-if="errors['text']">{{
                                        errors['text'][0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-6 sm:col-span-2 flex items-center">
                                <div class="flex items-center h-5">
                                    <input v-model="form.blank" id="link_blank" name="comments" type="checkbox"
                                           class="focus:ring-indigo-500 h-6 w-6 text-indigo-600 border-gray-300 rounded">
                                </div>
                                <div class="ml-3 text-sm">
                                    <label for="link_blank" class="font-medium text-gray-700">Open in a new
                                        window</label>
                                </div>
                            </div>
                            <div class="col-span-6">
                                <label for="link_href"
                                       class="block text-sm font-medium leading-5 text-gray-700">URL
                                </label>
                                <div class="mt-1">
                                    <InputText id="link_href" v-model="form.href"/>
                                    <div class="text-red-400 text-sm" v-if="errors['href']">{{
                                        errors['href'][0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SecondaryButton type="submit" class="mt-3">
                            Add new link
                        </SecondaryButton>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import SecondaryButton from "@/Jetstream/SecondaryButton";
    import InputText from "@/Jobroll/InputText";

    export default {
        name: "EditMenuLinks",
        components: {
            SecondaryButton,
            InputText
        },
        props: {
            menuLinks: Array,
            errors: Object
        },
        data() {
            return {
                form: this.$inertia.form({
                    text: null,
                    blank: false,
                    href: null
                })
            }
        },
        methods: {
            submit() {
                this.form.post('/settings/links', {preserveScroll: true});
            },
            deleteLink(id) {
                this.$inertia.post(`/settings/links/${id}`, {'_method': 'delete'}, { preserveScroll: true });
            }
        }
    }
</script>
